import { Alert, Stack } from "@mui/material";
import { RHFAutocomplete } from "src/components/hook-form";
import { companySizeData, industryData } from "./registerFormConfig";
import { ChangeEvent } from "react";
import { ICountry } from "src/utils/countryData";
import MarketingCheckboxes from "./MarketingCheckboxes";

type Step2Props = {
  countryOptions: ICountry[];
  isSubmittingAgreement: boolean;
  handleTermsAgreementChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handlePromotionChange: (event: any) => void;
  isSendMonthlyNewsletter: boolean;
  errors: any;
};

export default function Step2({
  countryOptions,
  isSubmittingAgreement,
  handleTermsAgreementChange,
  handlePromotionChange,
  errors,
  isSendMonthlyNewsletter
}: Step2Props) {
  return (
    <Stack spacing={2} sx={{ my: 2 }}>
    {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}

    <RHFAutocomplete
      name="country"
      label="Country"
      countryOptions={countryOptions}
    />

    <RHFAutocomplete
      name="industryCode"
      label="Industry"
      countryOptions={industryData}
    />

    <RHFAutocomplete
      name="companySize"
      label="Company size"
      countryOptions={companySizeData}
    />

    <MarketingCheckboxes
      isSubmittingAgreement={isSubmittingAgreement}
      handleTermsAgreementChange={handleTermsAgreementChange}
      handlePromotionChange={handlePromotionChange}
      isSendMonthlyNewsletter={isSendMonthlyNewsletter}
    />

  </Stack>
  );
}
